import { INITIAL_LISTINGS, INITIAL_TRADES, INITIAL_WITHDRAWALS } from '../domain/marketplaceSeed';
import { Listing, TradeRecord, WithdrawalRecord } from '../domain/marketplaceTypes';

type MarketplaceSnapshot = {
  listings: Listing[];
  trades: TradeRecord[];
  withdrawals: WithdrawalRecord[];
  actionKeys: string[];
};

export type { MarketplaceSnapshot };

const STORAGE_PREFIX = 'marketplace:v1:';

function keyForBusiness(businessId: string | null): string {
  return `${STORAGE_PREFIX}${businessId || 'default'}`;
}

export function loadMarketplaceSnapshot(businessId: string | null): MarketplaceSnapshot {
  const raw = localStorage.getItem(keyForBusiness(businessId));
  if (!raw) {
    return {
      listings: INITIAL_LISTINGS,
      trades: INITIAL_TRADES,
      withdrawals: INITIAL_WITHDRAWALS,
      actionKeys: [],
    };
  }

  try {
    const parsed = JSON.parse(raw) as Partial<MarketplaceSnapshot>;
    return {
      listings: parsed.listings || INITIAL_LISTINGS,
      trades: parsed.trades || INITIAL_TRADES,
      withdrawals: parsed.withdrawals || INITIAL_WITHDRAWALS,
      actionKeys: parsed.actionKeys || [],
    };
  } catch {
    return {
      listings: INITIAL_LISTINGS,
      trades: INITIAL_TRADES,
      withdrawals: INITIAL_WITHDRAWALS,
      actionKeys: [],
    };
  }
}

export function saveMarketplaceSnapshot(businessId: string | null, snapshot: MarketplaceSnapshot): void {
  localStorage.setItem(keyForBusiness(businessId), JSON.stringify(snapshot));
}
